import script from "./Register.vue?vue&type=script&setup=true&lang=ts"
export * from "./Register.vue?vue&type=script&setup=true&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=71c4f456&scoped=true&lang=css"
script.__scopeId = "data-v-71c4f456"

export default script